import { FC, useCallback, useState } from 'react';
import { Modal, ModalBody } from 'react-bootstrap';

import { ConnectedUserPreferencesForm } from './form';
import type { UserPreferencesButtonProps } from './UserPreferencesButton.connect';

export const UserPreferencesButton: FC<UserPreferencesButtonProps> = ({ onOpened, counterpartApi }) => {
  const [isModalOpened, setIsModalOpened] = useState(false);

  const toggleIsModalOpened = useCallback(() => {
    if (!isModalOpened) {
      onOpened();
    }
    setIsModalOpened(!isModalOpened);
  }, [isModalOpened, onOpened]);

  const onClose = useCallback(() => setIsModalOpened(false), []);

  return (
    <>
      <button
        className="btn btn-lg btn-icon btn-flat-primary"
        data-e2e="UserPreferences-button"
        ui-sref="user-preferences"
        title="User preferences"
        onClick={toggleIsModalOpened}
      >
        <i className="sgwt-widgets-icon icon">settings</i>
      </button>
      <Modal show={isModalOpened} onHide={toggleIsModalOpened} size="xl" enforceFocus={false}>
        <ModalBody className="p-0">
          <ConnectedUserPreferencesForm onClose={onClose} clientSearchApi={counterpartApi} />
        </ModalBody>
      </Modal>
    </>
  );
};
UserPreferencesButton.displayName = 'UserPreferencesButton';
